
import { defineComponent } from "vue";
import CameraForm from "@/components/stations/camera/CameraForm.component.vue";
import { Station } from "@/types/station.type";
import { Image } from "@/types/Image.type";
import { getLastImageStation } from "@/service/image.service";
import StationImageComponent from "@/components/stations/StationImage.component.vue";
import StationImagesModalComponent from "@/components/stations/StationImagesModal.component.vue";
import { useStore } from "vuex";
import { RootState } from "@/types/state.type";
import { getDetailStation } from "@/service/station.service";
import { getCameraConfiguration } from "@/service/cameraConfiguration.service";
import { CameraConfiguration, CameraConfigurationHistory } from "@/types/cameraconfiguration.type";

export default defineComponent({
  components: { StationImageComponent, StationImagesModalComponent, CameraForm },
  props: {
    lastImage: {
      type: Object as () => Image | undefined,
      required: true,
    },
  },
  setup() {
    const store = useStore<RootState>();

    return { store };
  },
  data() {
    return {
      editableTabsValue: {} as CameraConfiguration,
      lastImageCamera: {} as Image | undefined,
      isModalImageVisible: false,
      isModalCameraVisible: false,
      camera: "",
      station_id: this.$route.params.stationid,
      stationEntity: {} as Station,
      configurationCamera: {} as CameraConfiguration,
      cameraConfigTest: {} as CameraConfigurationHistory,
    };
  },
  computed: {
    // stationEntity(): Station {
    //   return this.store.state.station.station;
    // },
  },
  async mounted() {
    await this.getEditableTabsValue();
    await this.getLastImage();
  },
  methods: {
    seeImages() {
      this.isModalImageVisible = true;
    },
    async getLastImage() {
      if (this.stationEntity.station) {
        this.lastImageCamera = await getLastImageStation(
          this.stationEntity.station,
          this.editableTabsValue?.camera?.code,
          this.editableTabsValue?.numCamera
        );
      }
    },

    closeModalImage() {
      this.isModalImageVisible = false;
    },

    closeModalCamera() {
      this.isModalCameraVisible = false;
    },

    async getEditableTabsValue() {
      //const station = this.store.state.station.station;
      const station = await getDetailStation(this.station_id as string);

      if (
        station.stationsCamera &&
        station.stationsCamera.length > 0 &&
        station.stationsCamera[0].camera?.code
      ) {
        this.editableTabsValue = station.stationsCamera[0];
        await this.getLastImage();
      }
      this.stationEntity = station;
    },

    async editConfiguration(item: CameraConfiguration) {
      if (item.camera?.code && this.stationEntity.id) {
        this.camera = `${item.camera.code}${item.numCamera}`;
        await getCameraConfiguration(this.stationEntity.id, item.camera.code, item.numCamera).then(
          (configuration) => {
            this.configurationCamera = configuration;
            this.isModalCameraVisible = true;
          }
        );
        this.cameraConfigTest = {
          station: this.stationEntity.id,
          numCamera: this.editableTabsValue.numCamera,
          cameraType: this.configurationCamera.camera?.code,
          modele: this.configurationCamera.modele,
          brightness: this.configurationCamera.brightness,
          contrast: this.configurationCamera.contrast,
          saturation: this.configurationCamera.saturation,
          hue: this.configurationCamera.hue,
          autoWhiteBalanceEnabled: this.configurationCamera.autoWhiteBalanceEnabled,
          manualWhiteBalance: this.configurationCamera.manualWhiteBalance,
          gamma: this.configurationCamera.gamma,
          gain: this.configurationCamera.gain,
          sharpeness: this.configurationCamera.sharpeness,
          autoExposure: this.configurationCamera.autoExposure,
          intervals: {
            interval1: this.configurationCamera.intervals?.interval1 ?? null,
            interval2: this.configurationCamera.intervals?.interval2 ?? null,
            interval3: this.configurationCamera.intervals?.interval3 ?? null,
            interval4: this.configurationCamera.intervals?.interval4 ?? null,
          },
          exposures: {
            exposure1: this.configurationCamera.exposures?.exposure1 ?? null,
            exposure2: this.configurationCamera.exposures?.exposure2 ?? null,
            exposure3: this.configurationCamera.exposures?.exposure3 ?? null,
            exposure4: this.configurationCamera.exposures?.exposure4 ?? null,
            exposure5: this.configurationCamera.exposures?.exposure5 ?? null,
          },
          filterPosition: this.configurationCamera.filterPosition,
          dirtThreshold: this.configurationCamera.dirtThreshold,
        };
      }
    },
  },
});
